var React = require('react');
var ReactDOM = require('react-dom');
var css = require('./module.scss');
var dialogId = '__caih_fireplug_dialog__';
var dialogControllerFactory = function(id, mountPointClass = "") {
    return {
        renderDialog: function(config) {

            /* config:{
                containerId:'',
                content:'',
                visible:0/1,
                style:{},
                wrapClassName:'',
                mask:true/false,
                onMaskClick:function
            } */
            var ele = document.getElementById(id || dialogId);
            if (ele == null) {
                var body = document.getElementsByTagName('body')[0];
                var dialogEle = document.createElement('div');
                dialogEle.id = id || dialogId;
                var className = ['caih-fireplug-dialog-mount-point', mountPointClass].filter(e => e).join(" ");
                dialogEle.className = className;
                body.appendChild(dialogEle);
                ele = dialogEle;
            }

            ReactDOM.render(
                <Dialog
                    ref={function(dialogInstance) {
                        this.dialogInstance = dialogInstance;
                    }.bind(this)}
                    visible={config.visible}
                    style={config.style}
                    wrapClassName={config.wrapClassName}
                    mask={config.mask}
                    onMaskClick={config.onMaskClick}>
                    {config.content}
                </Dialog>, ele
            );
        },
        destroy: function() {
            var ele = document.getElementById(id || dialogId);
            ReactDOM.render(<Dialog visible={false}/>, ele);
        }
    };
};
var Dialog = React.createClass({
    render: function() {
        var props = this.props;
        var cls = ['fp-dialog', props.wrapClassName];
        var style = props.style;
        var view;
        if (props.visible) {
            view = <div>
                {props.mask ? <div className={'fp-mask'}></div> : ''}
                <div className={cls.join(' ')} onClick={props.mask ? this.mask : null} style={style}>
                    {this.props.children}
                </div>
            </div>;
        } else {
            view = <div className=""></div>;
        }
        return view;
    },
    mask: function() {
        var props = this.props || {};
        if (props.onMaskClick) {
            props.onMaskClick();
        }

    },
    getHW: function() {
        var winHeight;
        var winWidth;
        // 在<!DOCTYPE html>下，以下各属性表现
        if (window.innerWidth) {
            winWidth = window.innerWidth; // 现代浏览器都支持，IE8不支持，在标签下
        } else if ((document.body) && (document.body.clientWidth)) {
            winWidth = document.body.clientWidth; // 这个属性所有的浏览器都支持
        }

        if (window.innerHeight) {
            winHeight = window.innerHeight; // 现代浏览器都支持，IE8不支持
        } else if ((document.body) && (document.body.clientHeight)) {
            winHeight = document.body.clientHeight; // 所有浏览器都为0
        }

        if (document.documentElement &&
            document.documentElement.clientHeight &&
            document.documentElement.clientWidth) {
            winHeight = document.documentElement.clientHeight; // IE8以上所有浏览器都支持
            winWidth = document.documentElement.clientWidth; // IE8以上所有浏览器都支持
        }

        return {
            width: winWidth,
            height: winHeight
        };
    }
});

module.exports = dialogControllerFactory;



// WEBPACK FOOTER //
// ./component/dialog/factory.js